export const inviteFriend = {
  inviteFriendEmail: "Email",
  inviteFriendEmailError: "Invalid email",
  inviteFriendDate: "Date",
  inviteFriendButton: "Invite",
  inviteFriendRegistered: "Registered Friends",
  inviteFriendLoadingList: "Loading guest list...",
  inviteFriendNoReferrals: "No registered friends.",
  inviteFriendToSeeThemHere: "Invite friends to see them here",
};
